(ns kyber.components.composite.event-tracker
  (:require [cljs.spec.alpha :as s]
            [reagent.core :as reagent]
            [reagent.dom :as reagent-dom]
            [re-frame.core :as re-frame]
            [goog.object :as gobj]

            [kyber.events.dom-event-map :refer [dom-tags]]))

(s/def ::var #(or (var? %)
                  (map? %)))
(s/def ::context #(or (fn? %) (map? %)))
(s/def ::tag simple-keyword?)
(s/def ::event-spec
  (s/keys :req-un [::var
                   ::tag]
          :opt-un [::context]))

(s/def ::id simple-keyword?)
(s/def ::version number?)
(s/def ::variant simple-keyword?)
(s/def ::var-spec
  (s/keys :req-un [::id
                   ::version
                   ::variant]))

(s/def ::doc string?)
(s/def ::name string?)
(s/def ::doc-spec
  (s/keys :req-un [::doc
                   ::name]))

(defn- error-message-event-spec
  [spec-error]
  (str "Invalid event tracker spec \n\n" spec-error))

(defn- error-message-var-spec
  [spec-error]
  (str "Invalid event tracker spec \n\n" spec-error))

(defn- error-message-doc-spec
  [spec-error tag-name]
  (str "Invalid event doc spec '" tag-name "'.\n\n" spec-error))

(defn event-tracker
  "This higher order component wraps any UI component and attaches
  DOM events to if for the purposes of analytics"
  [event-spec _]
  (when ^boolean js/goog.DEBUG
    (let [metadata (if (var? (:var event-spec))
                     (meta (:var event-spec))
                     (:var event-spec))
          doc-spec (get dom-tags (:tag event-spec))]

      (when-not (s/valid? ::event-spec event-spec)
        (js/console.error
         (error-message-event-spec (s/explain-data ::event-spec event-spec))))

      (when-not (s/valid? ::var-spec metadata)
        (js/console.error
         (error-message-var-spec (s/explain-data ::var-spec metadata))))

      (when-not (s/valid? ::doc-spec doc-spec)
        (js/console.error
         (error-message-doc-spec (s/explain-data ::doc-spec doc-spec)
                                 (:tag event-spec))))))

  (let [{component-var :var
         component-context :context
         component-tag :tag} event-spec
        {:keys [id version variant]} (if (var? component-var)
                                       (meta component-var)
                                       component-var)
        component-data {:tag component-tag
                        :id id
                        :version version
                        :variant variant}
        dispatch-dom-event (fn [dom-action dom-event]
                             (re-frame/dispatch
                              [:analytics/save-datapoint
                               {:event (keyword "dom-event" dom-action)
                                :event-version 0
                                :dom-event-uuid (gobj/get dom-event
                                                          "kyber-event-uuid")
                                :component (assoc component-data
                                                  :context
                                                  (cond
                                                    (map? component-context)
                                                    component-context

                                                    (fn? component-context)
                                                    (component-context)

                                                    :else

                                                    {}))}]))
        ;; NOTE: A unique uuid is attached to every kyber DOM event to help
        ;;       distinguish actions. For example, if a button in embeded in
        ;;       a card and both elements are being tracked, when the user
        ;;       clicks on the button it will fire two click events, one for
        ;;       the card and one for the button. This is essentially the same
        ;;       action. To correlate the events, we can add a uuid to the event
        ;;       object (which is shared and bubbled), that way when it's passed
        ;;       up to the next element, it can add one if it doesn't exist. If
        ;;       if does exist, the two events are now correlated.
        ensure-event-uuid (fn [wrapped-function]
                            (fn [event]
                              (when (nil? (gobj/get event "kyber-event-uuid"))
                                (gobj/set event
                                          "kyber-event-uuid"
                                          (str (random-uuid))))

                              (wrapped-function event)))
        click-fn #(dispatch-dom-event "click" %)
        mouse-over-fn #(dispatch-dom-event "mouseover" %)
        mouse-out-fn #(dispatch-dom-event "mouseout" %)]
    (reagent/create-class
     {:component-did-mount
      (fn [this]
        (let [node (reagent-dom/dom-node this)]
          (.addEventListener node "click" (ensure-event-uuid click-fn))
          (.addEventListener node "mouseover" (ensure-event-uuid mouse-over-fn))
          (.addEventListener node "mouseout" (ensure-event-uuid mouse-out-fn))))
      :component-will-unmount
      (fn [this]
        (let [node (reagent-dom/dom-node this)]
          (.removeEventListener node "click" click-fn)
          (.removeEventListener node "mouseover" mouse-over-fn)
          (.removeEventListener node "mouseout" mouse-out-fn)))
      :reagent-render
      (fn [_metadata component]
        component)})))
